var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAcFanOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-ac_fan_only") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,4 C22.6,4 21.2,12.5 21,16.1 C20.7,16 20.3,16 20,16 C19.9,16 19.8,16 19.6,16 C19.3,15.1 19,13.7 19,12 C19,9 20,6 20,4 C20,2 18,0 15,0 C12,0 4,2 4,10 C4,17.4 12.5,18.8 16.1,19 C16,19.3 16,19.7 16,20 C16,20.1 16,20.2 16,20.4 C15.1,20.7 13.7,21 12,21 C9,21 6,20 4,20 C2,20 0,22 0,25 C0,28 2,36 10,36 C17.4,36 18.8,27.5 19,23.9 C19.3,24 19.7,24 20,24 C20.1,24 20.2,24 20.4,24 C20.7,24.9 21,26.3 21,28 C21,31 20,34 20,36 C20,38 22,40 25,40 C28,40 36,38 36,30 C36,22.6 27.5,21.2 23.9,21 C24,20.7 24,20.3 24,20 C24,19.9 24,19.8 24,19.6 C24.9,19.3 26.3,19 28,19 C31,19 34,20 36,20 C38,20 40,18 40,15 C40,12 38,4 30,4 Z M18,20 C18,18.9 18.9,18 20,18 C21.1,18 22,18.9 22,20 C22,21.1 21.1,22 20,22 C18.9,22 18,21.1 18,20 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons---\\u2660\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-ac_fan_only"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/White---White-80",
    mask: "url(#mask-2)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-dummy-icon",
    stroke: "#FF6666",
    strokeWidth: 2,
    strokeDasharray: "2,3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L46,46",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L46,46",
    id: "Line-Copy",
    transform: "translate(24.000000, 24.000000) scale(-1, 1) translate(-24.000000, -24.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcFanOnly);
export default __webpack_public_path__ + "static/media/icon-ac_fan_only.94e88428e59b737bcccecc719563ea11.svg";
export { ForwardRef as ReactComponent };